import { categoryFromFundingMethod } from "./catalog";

/** Funding methods that need a stored payment instrument at bind time. */
export const fundingMethodRequiresInstrument = (
  method: string | null | undefined
): boolean => {
  const category = categoryFromFundingMethod(method);
  return category === "CARD" || category === "ACCOUNT";
};
